export enum State {    
    Alabama = 1,
    Alaska = 2,
    Arizona = 3,
    Arkansas = 4,
    California = 5,
    Colorado = 6,
    Connecticut = 7,
    Delaware = 8,
    DistrictOfColumbia = 9,
    Florida = 10,
    Georgia = 11,
    Hawaii = 12,
    Idaho = 13,
    Illinois = 14,
    Indiana = 15,
    Iowa = 16,
    Kansas = 17,
    Kentucky = 18,
    Louisiana = 19,
    Maine = 20,
    Maryland = 21,
    Massachusetts = 22,
    Michigan = 23,
    Minnesota = 24,
    Mississippi = 25,
    Missouri = 26,
    Montana = 27,
    Nebraska = 28,
    Nevada = 29,
    NewHampshire = 30,
    NewJersey = 31,
    NewMexico = 32,
    NewYork = 33,
    NorthCarolina = 34,
    NorthDakota = 35,
    Ohio = 36,
    Oklahoma = 37,
    Oregon = 38,
    Pennsylvania = 39,
    RhodeIsland = 40,
    SouthCarolina = 41,
    SouthDakota = 42,
    Tennessee = 43,
    Texas = 44,
    Utah = 45,
    Vermont = 46,
    Virginia = 47,
    Washington = 48,
    WestVirginia = 49,
    Wisconsin = 50,
    Wyoming = 51,
    AmericanSamoa = 52,
    Guam = 53,
    NorthernMarianaIslands = 54,
    PuertoRico = 55,
    USVirginIslands = 56
}